<script >

import OurServices from "@/components/OurServices.vue";
import SideContactComponent from "@/components/SideContactComponent.vue";
import AddressComponent from "@/components/AddressComponent.vue";

export default{
  name:"InsurersPage",
  components: {AddressComponent, SideContactComponent, OurServices}
}
</script>

<template>
  <header class="uui-section_blogpost05-7">
    <div class="uui-page-padding-49">
      <div class="uui-container-large-39">
        <div class="uui-padding-vertical-xhuge-51">
          <div class="w-layout-grid uui-blogpost05_header-7">
            <div id="w-node-f17d7432-332b-3d7b-38e1-7b5b4c4f6395-34d61b98" class="uui-blogpost05_title-wrapper-7">
              <div class="uui-space-large-7"></div>
              <div class="uui-button-row-12">
                <router-link data-w-id="f17d7432-332b-3d7b-38e1-7b5b4c4f6398" to="/" class="uui-button-link-10 w-inline-block">
                  <div class="uui-button-icon-11 w-embed"><svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8332 10.0003H4.1665M4.1665 10.0003L9.99984 15.8337M4.1665 10.0003L9.99984 4.16699" stroke="CurrentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg></div>
                  <div>{{$t('InsurersPage.home')}}</div>
                </router-link>
              </div>
              <h1 class="uui-heading-large-15">{{$t('InsurersPage.title')}}</h1>
              <div class="uui-space-large-7"></div>
              <div class="text-block-13">{{$t('InsurersPage.subtitle')}}</div>
              <address-component></address-component>
            </div>
            <div id="w-node-f17d7432-332b-3d7b-38e1-7b5b4c4f63a2-34d61b98" class="uui-blogpost05_image-wrapper-7"><img src="../../public/images/Logo-Aseguradoras-HAM.png" loading="lazy" alt="" class="uui-blogpost03_image-2 image_aseguradoras" style="object-fit: contain !important;"></div>
          </div>
          <div class="uui-blogpost05_content-wrapper-8">
            <div class="uui-blogpost05_content-left-4">
              <div class="uui-blogpost05_content-left-2">
                <our-services></our-services>
                <side-contact-component></side-contact-component>
              </div>
            </div>
            <div id="w-node-_4056481c-d0c3-e1be-1f5f-39c9e19cc3a9-34d61b98" class="uui-blogpost05_content-2">
              <div class="uui-text-rich-text-3 w-richtext">
                <h4>{{$t('InsurersPage.purposes-title')}}</h4>
                <p><strong><em>{{$t('InsurersPage.purposes-p1')}}</em></strong></p>
                <p>{{$t('InsurersPage.purposes-p2')}}</p>
              </div>

              <div class="div-block-23">
                <div class="uui-text-rich-text-3 w-richtext">
                  <p><strong>{{$t('InsurersPage.international')}}</strong></p>
                </div>
                <ul role="list">
                  <li>{{$t('InsurersPage.international-li1')}}</li>
                  <li>{{$t('InsurersPage.international-li2')}}</li>
                  <li>{{$t('InsurersPage.international-li3')}}</li>
                  <li>{{$t('InsurersPage.international-li4')}}</li>
                  <li>{{$t('InsurersPage.international-li5')}}</li>
                  <li>{{$t('InsurersPage.international-li6')}}</li>
                  <li>{{$t('InsurersPage.international-li7')}}</li>
                  <li>{{$t('InsurersPage.international-li8')}}</li>
                  <li>{{$t('InsurersPage.international-li9')}}</li>
                </ul>
              </div>
              <div class="div-block-24">
                <div class="uui-text-rich-text-3 w-richtext">
                  <p><strong>{{$t('InsurersPage.national')}}</strong></p>
                </div>
                <ul role="list">
                  <li>{{$t('InsurersPage.national-li1')}}</li>
                  <li>{{$t('InsurersPage.national-li2')}}</li>
                  <li>{{$t('InsurersPage.national-li3')}}</li>
                  <li>{{$t('InsurersPage.national-li4')}}</li>
                  <li>{{$t('InsurersPage.national-li5')}}</li>
                  <li>{{$t('InsurersPage.national-li6')}}</li>
                  <li>{{$t('InsurersPage.national-li7')}}</li>
                  <li>{{$t('InsurersPage.national-li8')}}</li>
                </ul>
              </div>
              <div class="uui-text-rich-text-3 w-richtext">
                <h4>{{$t('InsurersPage.purpose-of-the-service')}}</h4>
                <p>{{$t('InsurersPage.purpose-of-the-service-p1')}}</p>
              </div>
              <a href="#" class="rl_footer1_social-link-2 w-inline-block animate__animated  animate__fadeInLeft">
                <div class="rl_footer1_social-icon-2 w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                   height="24" viewbox="0 0 24 24" fill="none">
                  <path
                      d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
                      stroke="#30B298" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></div>
                <div class="rl_footer1_link-text-2">{{$t('InsurersPage.purpose-of-the-service-li1')}}</div>
              </a>
              <a href="#" class="rl_footer1_social-link-2 w-inline-block animate__animated  animate__fadeInLeft">
                <div class="rl_footer1_social-icon-2 w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                   height="24" viewbox="0 0 24 24" fill="none">
                  <path
                      d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
                      stroke="#30B298" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></div>
                <div class="rl_footer1_link-text-2">{{$t('InsurersPage.purpose-of-the-service-li2')}}</div>
              </a>
              <a href="#" class="rl_footer1_social-link-2 w-inline-block animate__animated  animate__fadeInLeft">
                <div class="rl_footer1_social-icon-2 w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                   height="24" viewbox="0 0 24 24" fill="none">
                  <path
                      d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
                      stroke="#30B298" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></div>
                <div class="rl_footer1_link-text-2">{{$t('InsurersPage.purpose-of-the-service-li3')}}</div>
              </a>
              <a href="#" class="rl_footer1_social-link-2 w-inline-block animate__animated  animate__fadeInLeft">
                <div class="rl_footer1_social-icon-2 w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                   height="24" viewbox="0 0 24 24" fill="none">
                  <path
                      d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
                      stroke="#30B298" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></div>
                <div class="rl_footer1_link-text-2">{{$t('InsurersPage.purpose-of-the-service-li4')}}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header></template>

<style scoped></style>
